import PropTypes from "prop-types";

const MediaCard = ({
	mediaType,
	title,
	description,
	thumbnailUrl,
	mediaUrl,
	lightboxGroupName,
	mediaSinglePageUrl,
	isSinglePageImage,
}) => {
	const renderMediaTypeIcon = () => {
		const assetsPath = wpApiSettings.bseit_assets_dir_url + "icons/";
		const iconClasses =
			"absolute z-50 w-10 h-10 top-1 left-1 rtl:left-auto rtl:right-1";
		switch (mediaType) {
			case "image":
				return (
					<img
						src={`${assetsPath}image-file.png`}
						alt="image-icon"
						className={iconClasses}
						loading="lazy"
					/>
				);
			case "image_group":
				return (
					<img
						src={`${assetsPath}image-file.png`}
						alt="image-group-icon"
						className={iconClasses}
						loading="lazy"
					/>
				);
			case "video":
				return (
					<img
						src={`${assetsPath}video-file.png`}
						alt="video-icon"
						className={iconClasses}
						loading="lazy"
					/>
				);
			case "audio":
				return (
					<img
						src={`${assetsPath}audio-file.png`}
						alt="audio-icon"
						className={iconClasses}
						loading="lazy"
					/>
				);
			case "pdf":
				return (
					<img
						src={`${assetsPath}pdf-file.png`}
						alt="pdf-icon"
						className={iconClasses}
						loading="lazy"
					/>
				);
			default:
				return <p>Unsupported media type</p>;
		}
	};

	if (mediaType === "image_group") {
		if (isSinglePageImage) {
			
			return (
				<a
					href={mediaUrl}
					data-fancybox={"gallery-" + lightboxGroupName}
					data-caption={description}
					className="flex overflow-hidden relative justify-center items-center w-full rounded-lg shadow-lg media-card group min-h-80 bg-darkGray"
				>
					<img
						alt={title}
						src={thumbnailUrl}
						className="object-cover absolute inset-0 w-full h-full"
						loading="lazy"
					/>
				</a>
			);
		} else {
			return (
				<a
					href={mediaSinglePageUrl}
					className="flex overflow-hidden relative justify-center items-center w-full rounded-lg shadow-lg media-card group min-h-80 bg-darkGray"
				>
					<img
						alt={title}
						src={thumbnailUrl}
						className="object-cover absolute inset-0 w-full h-full"
						loading="lazy"
					/>
				</a>
			);
		}
	} else {
		return (
			<a
				href={mediaUrl}
				data-fancybox={"gallery-" + lightboxGroupName}
				data-caption={description}
				className="flex overflow-hidden relative justify-center items-center w-full rounded-lg shadow-lg media-card group min-h-80 bg-darkGray"
			>
				<img
					alt={title}
					src={thumbnailUrl}
					className="object-cover absolute inset-0 w-full h-full"
					loading="lazy"
				/>
				{renderMediaTypeIcon()}
				<div className="flex relative items-end p-4 mt-auto w-full h-full bg-opacity-0 rounded-lg transition-colors sm:p-6 lg:p-8 group-hover:bg-white group-hover:bg-opacity-85 group-hover:backdrop-blur-sm">
					<div className="opacity-0 transition-all transform translate-y-8 media-info group-hover:translate-y-0 group-hover:opacity-100">
						<h3 className="mb-2 text-lg font-bold line-clamp-1 text-primary media-title">
							{title}
						</h3>
						<p className="text-sm line-clamp-2 text-body media-description">
							{description}
						</p>
					</div>
				</div>
			</a>
		);
	}
};

MediaCard.propTypes = {
	mediaType: PropTypes.oneOf(["image", "image_group", "video", "audio", "pdf"]),
	title: PropTypes.string,
	description: PropTypes.string,
	thumbnailUrl: PropTypes.string,
	mediaUrl: PropTypes.string,
	lightboxGroupName: PropTypes.string,
};

export default MediaCard;
